import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    description: 'Please check spelling or try different keywords.',
    title: 'No results found',
  },
  fr: {
    description: 'Vérifiez l’orthographe ou essayez avec un autre mot-clé.',
    title: 'Aucun résultat',
  },
} as const);

export default locales;
